import { Stack, Typography } from '@mui/material';

import { IconButton } from '@/components/form/baseInputs/Button/IconButton';
import { ChevronRightIcon } from '@/components/icons/ChevronRightIcon';
import { RichListItem } from '@/components/lists/RichListItem/RichListItem';
import {
  DisplayTable,
  StyledTableCell,
} from '@/components/tables/DisplayTable/DisplayTable';
import { StyledTableRow } from '@/components/tables/DisplayTable/StyledTableRow';
import { useFamilyTreeContext } from '@/modules/familyTree/contexts';
import { FamilyTreeWarningType } from '@/types/schema';
import { getNodes } from '@/utils/graphqlUtils';

export function UnlinkedPanel() {
  const { state, dispatch } = useFamilyTreeContext();

  const unlinkedHouseholdMembersClientProfileIds =
    state.familyTreeData?.warnings
      .filter(
        (warning) => warning.type === FamilyTreeWarningType.UnlinkedFamilyMember
      )
      .flatMap((warning) => warning.clientProfileIds);
  return (
    <Stack spacing={2}>
      <Typography variant="body-s">
        The following individuals will appear on the family tree once you have
        specified relationships that link them back to this household&apos;s
        client(s)
      </Typography>
      <DisplayTable
        hideTableHead
        showOuterRowBorders
        columns={[{ headerName: 'Individual' }, { headerName: 'Action' }]}
      >
        {unlinkedHouseholdMembersClientProfileIds?.flatMap((id) => {
          const profile = getNodes(state.clientProfiles).find(
            (cp) => cp.id === id
          );

          const hasRelationships = (profile?.relationships?.length ?? 0) > 0;

          if (!profile) {
            return [];
          }

          const openPerson = () =>
            dispatch({
              type: 'OPEN_SIDE_PANEL',
              personId: id,
              history: ['unlinked'],
            });

          return (
            <StyledTableRow
              key={id}
              onClick={openPerson}
              tabIndex={0}
              onKeyDown={(event) => {
                if (
                  event.target === event.currentTarget &&
                  (event.key === 'Enter' || event.key === ' ')
                ) {
                  event.preventDefault();
                  openPerson();
                }
              }}
            >
              <StyledTableCell>
                <RichListItem
                  heading={profile.displayName}
                  description={
                    hasRelationships ? 'Partially linked' : undefined
                  }
                />
              </StyledTableCell>
              <StyledTableCell align="right">
                <IconButton
                  icon={ChevronRightIcon}
                  ariaLabel={`View ${profile.displayName}`}
                  variant="transparent"
                  size="xs"
                  onClick={(event) => {
                    event.stopPropagation();
                    openPerson();
                  }}
                />
              </StyledTableCell>
            </StyledTableRow>
          );
        })}
      </DisplayTable>
    </Stack>
  );
}
